import React from "react";
import Dialog from "@material-ui/core/Dialog";
import logo from "../img/MUSEA_Logo_2026.png";
import "../css/newOrderingSystemModal.css";

export default function NewOrderingSystemModal() {
  return (
    <Dialog
      open
      disableBackdropClick
      disableEscapeKeyDown
      className="new-ordering-system-modal"
      classes={{ paper: "new-ordering-system-modal__paper" }}
      aria-labelledby="new-ordering-system-title"
      aria-describedby="new-ordering-system-description"
    >
      <img src={logo} alt="Musea" className="new-ordering-system-modal__logo" />
      <h2 id="new-ordering-system-title">Exciting News!</h2>
      <p id="new-ordering-system-description">
        We have launched a new ordering system! Please use the new system for
        placing orders.
      </p>
      <a
        href="https://app.musealab.com/v2/"
        className="button-2 w-button new-ordering-system-modal__login"
      >
        Log In
      </a>
    </Dialog>
  );
}
